import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { Tooltip, toolkitCx } from "@sundae/ui-toolkit";
import cx from "classnames";
import isEmpty from "lodash/isEmpty";
import { FC } from "react";
import { usePersonalizedHandleData } from "../../../gql/hooks/handle.query";
import TasteTestPersonalization from "../../../i18n/components/taste-test/TasteTestPersonalization";
import { useTasteTestContext } from "../../../pages/TasteTestDetail/context";
import TasteTestAdaDepositedCounter from "../TasteTestAdaDepositedCounter";
import TasteTestBannerImage from "../TasteTestBannerImage";
import {
  TasteTestCountdown,
  TasteTestCountdownNode,
} from "../TasteTestDetailCountdown/TasteTestDetailCountdown";

const TasteTestBannerContainer: FC = () => {
  const {
    state: { tasteTest, tasteTestPersonalization },
  } = useTasteTestContext();
  const { data: personalizedHandleData, isLoading: isLoadingPersonalizedHandleData } =
    usePersonalizedHandleData(tasteTest?.adaHandle ?? "");
  const hasPersonalizedHandleData =
    !isLoadingPersonalizedHandleData && !isEmpty(personalizedHandleData);

  return (
    <div className="relative mt-4 h-40 w-full overflow-hidden rounded-tl-lg rounded-tr-lg lg:h-80">
      <div
        className={cx("absolute z-10 h-full w-full max-w-6xl", toolkitCx.recipes.center.horizontal)}
      >
        <div className="absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center gap-6 lg:left-8 lg:w-72 lg:flex-col xl:left-0">
          <div className="absolute -left-20 top-0 z-[-1] h-full w-[calc(100%+10rem)] bg-primary/10 backdrop-blur-sm lg:-skew-x-12 lg:backdrop-blur-lg" />
          <TasteTestAdaDepositedCounter />

          <TasteTestCountdown />
          <TasteTestCountdownNode />
        </div>

        {hasPersonalizedHandleData && (
          <Tooltip
            trigger={
              <div className="absolute right-4 top-4 z-10 h-4 w-4 cursor-help rounded-full xl:right-0">
                <InformationCircleIcon className={cx("h-4 w-4", toolkitCx.layout.text.light)} />
              </div>
            }
            tooltipLabel={<TasteTestPersonalization />}
          />
        )}
      </div>

      <TasteTestBannerImage tasteTestPersonalization={tasteTestPersonalization} />
    </div>
  );
};

export default TasteTestBannerContainer;
